import { colors } from '@ardoq/design-tokens';
import { ColorMapProps, StatusType } from './types';

export const perTypeColorMap: Record<StatusType, ColorMapProps> = {
  [StatusType.DEFAULT]: {
    borderColor: colors.borderAction,
    labelColor: colors.textDefault,
    iconColor: colors.icon,
    backgroundColor: colors.surfaceStatusNeutral,
    hoverBorderColor: colors.borderActionHover,
  },
  [StatusType.NEW]: {
    borderColor: colors.borderBrand,
    labelColor: colors.textBrand,
    iconColor: colors.iconBrand,
    backgroundColor: colors.surfaceBrand,
    hoverBorderColor: colors.borderBrandStrong,
  },
  [StatusType.ERROR]: {
    borderColor: colors.borderError,
    labelColor: colors.textError,
    iconColor: colors.iconError,
    backgroundColor: colors.surfaceError,
    hoverBorderColor: colors.borderErrorStrong,
  },
  [StatusType.WARNING]: {
    borderColor: colors.borderWarning,
    labelColor: colors.textWarning,
    iconColor: colors.iconWarning,
    backgroundColor: colors.surfaceWarning,
    hoverBorderColor: colors.borderWarningStrong,
  },
  [StatusType.SUCCESS]: {
    borderColor: colors.borderSuccess,
    labelColor: colors.textSuccess,
    iconColor: colors.iconSuccess,
    backgroundColor: colors.surfaceSuccess,
    hoverBorderColor: colors.borderSuccessStrong,
  },
  [StatusType.INFO]: {
    borderColor: colors.borderInfo,
    labelColor: colors.textInfo,
    iconColor: colors.iconInfo,
    backgroundColor: colors.surfaceInfo,
    hoverBorderColor: colors.borderInfoStrong,
  },
  [StatusType.SCENARIO]: {
    borderColor: colors.surfaceScenario,
    labelColor: colors.textOnInvertedStrong,
    backgroundColor: colors.surfaceScenario,
  },
  [StatusType.BETA]: {
    borderColor: colors.surfaceActionPrimary,
    labelColor: colors.textOnInvertedStrong,
    iconColor: colors.textOnInvertedStrong,
    backgroundColor: colors.surfaceActionPrimary,
  },
  [StatusType.TRIAL]: {
    borderColor: colors.pink600,
    labelColor: colors.textOnInvertedStrong,
    iconColor: colors.textOnInvertedStrong,
    backgroundColor: colors.pink600,
  },
  [StatusType.WORKSPACE]: {
    borderColor: colors.borderBrand,
    labelColor: colors.textBrand,
    iconColor: colors.iconBrand,
    backgroundColor: colors.surfaceBrand,
    hoverBorderColor: colors.borderBrandStrong,
  },
};
